/**
 * @generated SignedSource<<b8d68d879a58ad4771d9cfa37285d53b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AnalyticsValueUnit = "duration" | "percentage" | "unit";
export type SinglePeriodMetric = "ENGAGEMENT" | "PRODUCT_DATE_TRACKER_REGISTERED" | "PRODUCT_DATE_TRACKER_TASKS_COMPLETED" | "TASK_EXECUTIONS_COMPLETED" | "TODO_CREATED" | "TODO_ISSUE_CREATED" | "TODO_ISSUE_RESOLVED" | "TODO_ISSUE_RESOLVED_AVG_TIME" | "TODO_RESOLVED" | "TODO_RESOLVED_AVG_TIME";
import { FragmentRefs } from "relay-runtime";
export type SinglePeriodTable$data = {
  readonly dimensions: ReadonlyArray<{
    readonly label: string;
    readonly metrics: ReadonlyArray<{
      readonly avg: number | null;
      readonly metric: SinglePeriodMetric;
      readonly total: number | null;
    }>;
  }>;
  readonly metrics: ReadonlyArray<{
    readonly hasAvg: boolean | null;
    readonly hasTotal: boolean | null;
    readonly metric: SinglePeriodMetric;
    readonly valueUnit: AnalyticsValueUnit;
  }>;
  readonly " $fragmentType": "SinglePeriodTable";
};
export type SinglePeriodTable$key = {
  readonly " $data"?: SinglePeriodTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"SinglePeriodTable">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metric",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SinglePeriodTable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SinglePeriodAnalyticsMetric",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasAvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasTotal",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueUnit",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SinglePeriodAnalyticsDimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SinglePeriodAnalyticsDimensionMetric",
          "kind": "LinkedField",
          "name": "metrics",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "avg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SinglePeriodAnalytics",
  "abstractKey": null
};
})();

(node as any).hash = "902a7ed87109e8e8fd2db2ab06b0f180";

export default node;
